import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAvailableOptIns, useOptIns } from '@grandvisionhq/auth';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { pushLoginExpressRememberUserDetailsClickEventToDataLayer } from '../../../data-layer.js';
import { ConsentsContainer } from '../../../modules/Consents/containers/ConsentsContainer.js';
import { OptInsContainer } from '../../../modules/Consents/containers/OptInsContainer.js';
import { toSavedOptIns, getShownOptIns } from '../../../modules/Consents/utils/opt-ins.js';
import 'motion/react';
import '@grandvisionhq/state';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../StepShipping/selectors.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import { ImplicitAccountCreationContainer } from '../../../StepShipping/containers/ImplicitAccountCreationContainer.js';
import { ImplicitTermsAndConditionsContainer } from '../../../StepShipping/containers/ImplicitTermsAndConditionsContainer.js';
import { useLoggedInCheckout } from '../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { SaveDetailsToAccount } from './SaveDetailsToAccount.js';

const ConsentsAndOptInsContainer = ()=>{
    var ref1;
    const { availableOptIns  } = useAvailableOptIns();
    const { optInsFromServer  } = useOptIns();
    const { account , consent: consentSettings  } = useCheckoutSettings();
    const { isSaveDetailsInAccount , setIsSaveDetailsInAccount , optIns: acceptedOptIns , consents , setOptIns , updateConsents , isUserLoggedIn ,  } = useLoggedInCheckout();
    const allOptIns = (consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.optIns) || availableOptIns.filter((item)=>item.isInSignup
    );
    const savedOptIns = React.useMemo(()=>toSavedOptIns(optInsFromServer)
    , [
        optInsFromServer
    ]);
    const shownOptIns = React.useMemo(()=>getShownOptIns(allOptIns, savedOptIns)
    , [
        allOptIns,
        savedOptIns
    ]);
    const selectedConsents1 = React.useMemo(()=>{
        return consents === null || consents === void 0 ? void 0 : consents.filter((consent)=>consent.isChecked
        );
    }, [
        consents
    ]);
    const handleConsentChange = React.useCallback((selectedConsents)=>{
        const consentList = consents.map((consent1)=>swcHelpers.objectSpread({}, consent1, {
                isChecked: selectedConsents.map((consent)=>consent.value
                ).includes(consent1.value)
            })
        );
        updateConsents(consentList);
    }, [
        consents,
        updateConsents
    ]);
    const setConsents = React.useCallback(()=>{
        var ref;
        updateConsents((consentSettings === null || consentSettings === void 0 ? void 0 : (ref = consentSettings.items) === null || ref === void 0 ? void 0 : ref.map((consent)=>{
            return swcHelpers.objectSpread({}, consent, {
                isChecked: false
            });
        })) || []);
    }, [
        consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.items,
        updateConsents
    ]);
    const onChangeHandler = React.useCallback(({ checked  })=>{
        setIsSaveDetailsInAccount(checked);
        pushLoginExpressRememberUserDetailsClickEventToDataLayer({
            isLoggedIn: isUserLoggedIn
        });
    }, [
        isUserLoggedIn,
        setIsSaveDetailsInAccount
    ]);
    React.useEffect(()=>{
        setConsents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        consentSettings === null || consentSettings === void 0 ? void 0 : (ref1 = consentSettings.items) === null || ref1 === void 0 ? void 0 : ref1.length
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SaveDetailsToAccount, {
        checked: isSaveDetailsInAccount,
        onChange: onChangeHandler
    }), /*#__PURE__*/ React.createElement(OptInsContainer, {
        optIns: shownOptIns,
        selectedOptIns: acceptedOptIns !== null && acceptedOptIns !== void 0 ? acceptedOptIns : [],
        onChange: setOptIns,
        implicitAccountCreation: account === null || account === void 0 ? void 0 : account.implicitAccountCreation
    }), /*#__PURE__*/ React.createElement(ConsentsContainer, {
        consents: consents,
        selectedConsents: selectedConsents1,
        onChange: handleConsentChange
    }), /*#__PURE__*/ React.createElement(ImplicitTermsAndConditionsContainer, null), /*#__PURE__*/ React.createElement(ImplicitAccountCreationContainer, null));
};

export { ConsentsAndOptInsContainer };
//# sourceMappingURL=ConsentsAndOptinsContainer.js.map
